import { IconProps } from './types';

const Wifi = ({ color, dimension }: IconProps) => (
  <svg
    fill="none"
    height={dimension || 24}
    viewBox="0 0 24 24"
    width={dimension || 24}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00001 12.55C6.97658 10.9037 9.46762 10.0022 12.04 10.0022C14.6124 10.0022 17.1034 10.9037 19.08 12.55M1.42001 9.00004C4.34244 6.424 8.10431 5.00269 12 5.00269C15.8957 5.00269 19.6576 6.424 22.58 9.00004M8.53001 16.11C9.54522 15.3888 10.7597 15.0013 12.005 15.0013C13.2503 15.0013 14.4648 15.3888 15.48 16.11M12 20H12.01"
      stroke={color || '#101828'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export default Wifi;
